import styled from 'styled-components';
import colors from '../../../../styles/theme/colors';
import { sizes } from '../../../../styles/theme/devices';
import spaces from '../../../../styles/theme/spaces';

const ActionsBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${spaces.xs};
  width: 100%;
  margin-top: ${spaces.small};
  padding-top: ${spaces.xs};

  [data-testid='action-continue'] {
    background-color: ${colors.secondary.main};
    border-radius: 8px;
    padding: 8px 16px;
    min-height: 40px;
    font-family: 'Poppins', sans-serif;
    margin-left: auto;

    @media (min-width: ${sizes.tablet}) {
      padding: 10px 20px;
    }

    svg {
      height: 22px;
      width: 22px;
      margin: 0 0 0 6px;
    }
  }
`;

const ActionsSpacer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spaces.small};
  flex-wrap: wrap;
  min-height: 40px;
`;

const LinkButton = styled.button`
  appearance: none;
  background: transparent;
  border: none;
  color: ${colors.secondary.main};
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  padding: 0;
  text-decoration: none;

  &:hover:not(:disabled) {
    text-decoration: underline;
    color: ${colors.secondary.dark};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  @media (min-width: ${sizes.tablet}) {
    font-size: 15px;
  }
`;

export { ActionsBar, ActionsSpacer, LinkButton };
